<style>
    .v-environment-register .card {
        border: none;
        margin-bottom: 0px;
    }
</style>
<template>
    <div class="v-environment-register app flex-row align-items-center">
        <div class="container">
            <b-row class="justify-content-center">
                <b-col md="6" sm="8">
                    <b-card no-body class="mx-4">
                        <b-card-body class="p-4">

                            <div class="mb-3 text-center">
                                <img class="mb-4" :width="Core.Session.Setting.getSetting('environment.ui.login.logoWidth', '250px')"
                                     :src="Core.Session.Setting.getSetting('environment.ui.login.logo', Core.Session.Setting.getSetting('environment.ui.logoFull'))">
                                <h3 class="mt-3">{{Core.Text.format(Core.Definition.getDefinition('Étape {0} de 4'), dataStep.step)}}</h3>
                                <p>{{Core.Definition.getDefinition('Création de votre compte entreprise')}}</p>
                                <b-progress :value="dataStep.progress" variant="danger" class=""></b-progress>
                                <hr/>
                            </div>

                            <Request
                                    ref="request"
                                    :method="dataRequest.method"
                                    :onRequestSuccess="requestSuccess"
                                    :onRequestError="requestError"
                                    :root="dataRequest.root">
                                <slot slot="body">
                                    <CForm
                                            ref="form"
                                            @onSubmit="next"
                                            v-if="dataFormStructure.rows !== undefined"
                                            :options="{ submit: dataForm.submit }"
                                            :structure="dataFormStructure">
                                        <slot slot="planSelection">
                                            <div>
                                                <h5 class="mb-3">{{Core.Definition.getDefinition('Sélectionnez un forfait')}}</h5>
                                                <table class="table table-striped">
                                                    <tr v-for="plan, planKey in dataPlans">
                                                        <td><strong>{{plan.label}}</strong>
                                                        <p class="small text-muted" v-if="plan.description !== undefined && plan.description !== ''">
                                                            {{plan.description}}
                                                        </p>
                                                        </td>
                                                        <td>{{Core.Currency.format(plan.price)}} <small>{{Core.Definition.getDefinition('/ mois +tx')}}</small></td>
                                                        <td>
                                                            <b-button @click="switchPlan(planKey)" :class="{ 'btn-success' : dataPlans[planKey].selected === true,'btn-light' : dataPlans[planKey].selected === false}" class="btn btn-sm">
                                                                <i  class="fa fa-check"></i>
                                                            </b-button>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="3">
                                                            <a target="_blank" :href="Mantle.Config.site.URLPlans" class="btn btn-sm btn-primary">
                                                                {{Core.Definition.getDefinition('Détails sur les forfaits')}}
                                                            </a>

                                                            <a target="_blank" :href="Mantle.Config.site.URLDemo" class="btn btn-sm btn-primary ml-2">
                                                                {{Core.Definition.getDefinition('Démonstration gratuite')}}
                                                            </a>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <div class="mt-5">
                                                <h5 class="mb-3">{{Core.Definition.getDefinition('Un peu plus sur votre entreprise')}}</h5>
                                                <InputMultiSelect
                                                        :required="true"
                                                        v-model="dataEventTypes"
                                                        :options="dataSelectOptions.eventTypes"
                                                        :label="Core.Definition.getDefinition('Que sera le type d\'événement affiché à votre calendrier?')">
                                                </InputMultiSelect>
                                            </div>
                                        </slot>
                                        <slot slot="accountVerification">
                                            <div class="text-center">
                                                <h5>{{Core.Definition.getDefinition('Merci de faire confiance à Perfoplanning!')}}</h5>
                                                <Alert :alert="{ show: true, variant: 'light', message: Core.Definition.getDefinition('<b class=\'text-center font-2xl\'>Attention</b><br/> Votre environnement est en processus de création et de vérification! Vous recevrez vos accès par courriel, lorsque le processus sera terminé.') }"></Alert>
                                            </div>
                                        </slot>
                                        <slot slot="emailVerification">
                                            <div class="text-center">
                                                <h5>{{Core.Definition.getDefinition('Confirmez votre adresse courriel')}}</h5>
                                                <Alert :alert="{ show: true, variant: 'light', message: Core.Definition.getDefinition('Un courriel avec un lien de confirmation à été envoyé à votre adresse courriel. Veuillez confirmer votre adresse courriel pour continuer la création de votre compte entreprise.') }"></Alert>
                                            </div>
                                        </slot>
                                        <slot slot="beforeFormButtons">
                                            <b-button variant="primary" @click="login" class="mr-2">
                                                <i  class="fa fa-chevron-left mr-2"></i>{{Core.Definition.getDefinition('Connexion')}}
                                            </b-button>
                                        </slot>
                                    </CForm>
                                </slot>
                            </Request>

                        </b-card-body>
                    </b-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    import InputMultiSelect from "../../components/InputMultiSelect";
    var me = null
    import CForm from '../../components/CForm'
    import Request from '../../components/Request'
    import PGTokenization from '../../components/PGTokenization'
    import Alert from '../../components/Alert'
    export default {
        name: 'EnvironmentRegister',
        components: {
            InputMultiSelect,
            CForm,
            Request,
            Alert,
            PGTokenization
        },
        mounted() {
            me = this
            if (this.$route.params.environmentId !== undefined && this.$route.params.validationKey !== undefined) {
                this.validation(this.$route.params.environmentId, this.$route.params.validationKey)
            } else {
                this.displayForm(Core.Session.environment.status)
            }
        },
        data: function () {
            return {
                Core: window.Core,
                Mantle: window.Mantle,
                dataEventTypes: [],
                dataSelectOptions: {
                    eventTypes: []
                },
                dataRequest: {},
                dataStep: {
                  step: 1,
                  progress: 0
                },
                dataEnvironment: {},
                dataPlans: [],
                dataPlan: false,
                dataForm: {
                    submit: {},
                    structures: {
                        initial: {
                            rows: [
                                {
                                    cols: [
                                        {
                                            cards: [
                                                {
                                                    caption: Core.Definition.getDefinition('Informations de votre entreprise'),
                                                    options: {headerStyle: '2'},
                                                    rows: [
                                                        {
                                                            cols: [
                                                                {
                                                                    fields: [
                                                                        {
                                                                            id: 'companyName'
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            cols: [
                                                                {
                                                                    fields: [
                                                                        {
                                                                            id: 'companyAddress'
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            cols: [
                                                                {
                                                                    fields: [
                                                                        {
                                                                            id: 'companyCountry'
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            cols: [
                                                                {
                                                                    fields: [
                                                                        {
                                                                            id: 'companyProvince'
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            cols: [
                                                                {
                                                                    fields: [
                                                                        {
                                                                            id: 'companyCity'
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    fields: [
                                                                        {
                                                                            id: 'companyZipcode'
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    cols: [
                                        {
                                            cards: [
                                                {
                                                   caption: Core.Definition.getDefinition('Vos coordonnées'),
                                                   options: {headerStyle: '2'},
                                                   rows: [
                                                        {
                                                            cols: [
                                                                {
                                                                    fields: [
                                                                        {
                                                                            id: 'firstname'
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    fields: [
                                                                        {
                                                                            id: 'lastname'
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                         {
                                                           cols: [
                                                             {
                                                               fields: [
                                                                 {
                                                                   id: 'email'
                                                                 }
                                                               ]
                                                             },
                                                             {
                                                               fields: [
                                                                 {
                                                                   id: 'phone'
                                                                 }
                                                               ]
                                                             }
                                                           ]
                                                         },
                                                     {
                                                       cols: [
                                                         {
                                                           fields: [
                                                             {
                                                               id: 'password'
                                                             }
                                                           ]
                                                         },
                                                         {
                                                           fields: [
                                                             {
                                                               id: 'confirm'
                                                             }
                                                           ]
                                                         }
                                                       ]
                                                     }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                            ],
                            fields: [
                                {
                                    id: 'companyName',
                                    type: 'text',
                                    label: Core.Definition.getDefinition('Nom de votre entreprise'),
                                    required: true,
                                },
                                {
                                    id: 'companyAddress',
                                    type: 'text',
                                    label: Core.Definition.getDefinition('Adresse'),
                                    required: true
                                },
                                {
                                    id: 'companyCountry',
                                    type: 'country',
                                    label: Core.Definition.getDefinition('Pays'),
                                    required: false,
                                    value: {value: 'CA', label :'Canada'},
                                    onSelect: function(value, form, fieldRefs) {
                                        if (value !== null && value.value !== undefined) {
                                            fieldRefs['companyProvince'].retrieve(value.value)
                                        } else {
                                            fieldRefs['companyProvince'].dataValue = null
                                        }
                                    }
                                },
                                {
                                    id: 'companyProvince',
                                    type: 'province',
                                    value: {value: 'QC', label :'Quebec'},
                                    label: Core.Definition.getDefinition('Province'),
                                    required: false
                                },
                                {
                                    id: 'companyCity',
                                    type: 'text',
                                    label: Core.Definition.getDefinition('Ville'),
                                    required: true
                                },
                                {
                                    id: 'companyZipcode',
                                    type: 'text',
                                    label: Core.Definition.getDefinition('Code Postal'),
                                    required: true
                                },
                                {
                                    id: 'firstname',
                                    type: 'text',
                                    label: Core.Definition.getDefinition('Prénom'),
                                    required: true
                                },
                                {
                                    id: 'lastname',
                                    type: 'text',
                                    label: Core.Definition.getDefinition('Nom de famille'),
                                    required: true
                                },
                                {
                                    id: 'email',
                                    type: 'email',
                                    label: Core.Definition.getDefinition('Adresse courriel'),
                                    required: true
                                },
                                {
                                    id: 'phone',
                                    type: 'phone',
                                    label: Core.Definition.getDefinition('Téléphone'),
                                    required: true
                                },
                              {
                                id: 'password',
                                type: 'password',
                                label: Core.Definition.getDefinition('Mot de passe'),
                                required: true
                              },
                              {
                                id: 'confirm',
                                type: 'password',
                                label: Core.Definition.getDefinition('Confirmation'),
                                required: true
                              }
                            ]
                        },
                        emailVerification: {
                            rows: [
                                {
                                    cols: [
                                        {
                                            cards: [
                                                {
                                                    key: 'emailVerification'
                                                }
                                            ]
                                        }
                                    ]
                                },
                            ],
                            fields: []
                        },
                        plan: {
                            rows: [
                                {
                                    cols: [
                                        {
                                            cards: [
                                                {
                                                    key: 'planSelection'
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    cols: [
                                        {
                                            cards: [
                                                {
                                                    caption: Core.Definition.getDefinition('Moyen de paiement'),
                                                    id: 'CCCard',
                                                    options: {headerStyle: '2'},
                                                    rows: [
                                                        {
                                                            cols: [
                                                                {
                                                                    fields: [
                                                                        {
                                                                            id: 'CC'
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    options: {headerStyle: '2'},
                                                    rows: [
                                                        {
                                                            cols: [
                                                                {
                                                                    fields: [
                                                                        {
                                                                            id: 'acceptTerms'
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            cols: [
                                                                {
                                                                    fields: [
                                                                        {
                                                                            id: 'linkTerms'
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            cols: [
                                                                {
                                                                    fields: [
                                                                        {
                                                                            id: 'separator'
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                            ],
                            fields: [
                                {
                                    id: 'CC',
                                    type: 'CC',
                                    required: false,
                                    onTokenizationSuccess: function(token, form) {
                                        me.afterTokenization(token, form)
                                    }
                                },
                                {
                                    id: 'CCBrands',
                                    type: 'CCBrands',
                                    class: 'mt-3'
                                },
                                {
                                    id: 'separator',
                                    type: 'separator',
                                    class: 'mt-4',
                                },
                                {
                                    id: 'acceptTerms',
                                    type: 'checkbox',
                                    label: Core.Definition.getDefinition('J\'accepte les termes et conditions d\'utilisation de Perfoplanning.'),
                                    class: 'mt-3',
                                    labelCols: 9,
                                    onChange: function(value, form, fieldRefs) {}
                                },
                                {
                                    id: 'linkTerms',
                                    type: 'html',
                                    html: Core.Text.format(Core.Definition.getDefinition('<a target="_blank" class="btn-link" href="{0}">Termes et conditions d\'utilisation de Perfoplanning </a>'), Mantle.Config.site.URLTerms),
                                }
                            ]
                        },
                        accountVerification: {
                            rows: [
                                {
                                    cols: [
                                        {
                                            cards: [
                                                {
                                                    key: 'accountVerification'
                                                }
                                            ]
                                        }
                                    ]
                                },
                            ],
                            fields: []
                        },
                    }
                },
                dataFormStructure: {},
            }
        },
        methods: {
            switchPlan(planKey) {
                for(let planIndex in this.dataPlans) {
                    this.dataPlans[planIndex].selected = false
                }
                this.dataPlans[planKey].selected = true
                this.dataPlan = this.dataPlans[planKey]

                if (this.dataPlan.forceCC !== undefined) {
                    if (this.dataPlan.forceCC === false) {
                        document.getElementById('CCCard').style = 'display:none'
                    } else {
                        document.getElementById('CCCard').style = 'display:block'
                    }
                } else  {
                    document.getElementById('CCCard').style = 'display:block'
                }

            },
            validation(environmentId, validationKey) {
                this.displayForm(Core.Environment.statusStepEmailVerification)
                this.$refs.request.setRoot('/environment/validation')
                this.$refs.request.setMethod(Core.Request.methodGet)
                this.$refs.request.clearArgs()
                this.$refs.request.addArg('environmentId', environmentId)
                this.$refs.request.addArg('validationKey', validationKey)
                this.$refs.request.request()
            },
            displayForm(status) {
                switch(status) {
                    case Core.Environment.statusStepEmailVerification:
                        this.dataStep.progress = 33
                        this.dataStep.step = 2
                        this.dataFormStructure = this.dataForm.structures.emailVerification
                        this.dataForm.submit = {}
                        break
                    case Core.Environment.statusStepPlan:
                        this.dataFormStructure = this.dataForm.structures.plan
                        this.dataStep.progress = 66
                        this.dataStep.step = 3
                        this.dataForm.submit = {
                            text: Core.Definition.getDefinition('Confirmer') + '<i class="fa fa-chevron-right ml-2"></i>',
                            variant: 'primary',
                            classes: 'pull-right'
                        }
                        this.$refs.request.setRoot('/environment/confirm')
                        this.$refs.request.setMethod(Core.Request.methodPut)
                        break
                    case Core.Environment.statusStepAccountVerification:
                        this.dataFormStructure = this.dataForm.structures.accountVerification
                        this.dataStep.progress = 100
                        this.dataStep.step = 4
                        this.dataForm.submit = {}
                        break
                    case Core.Environment.statusPublish:
                        this.login()
                        break
                    default:
                        this.dataFormStructure = this.dataForm.structures.initial
                        this.dataStep.progress = 0
                        this.dataStep.step = 1
                        this.dataForm.submit = {
                            text: Core.Definition.getDefinition('Suivant') + '<i class="fa fa-chevron-right ml-2"></i>',
                            variant: 'primary',
                            classes: 'pull-right'
                        }
                        this.$refs.request.setRoot('/environment/initial')
                        this.$refs.request.setMethod(Core.Request.methodPost)
                        break
                }
            },
            next(form, fieldRefs) {
                switch (Core.Session.environment.status) {
                    case Core.Environment.statusStepPlan:
                        if (this.dataPlan.forceCC === undefined || this.dataPlan.forceCC === true) {
                            fieldRefs['CC'].getToken()
                        } else {
                            this.afterTokenization('', form)
                        }
                        break
                    default:
                        this.$refs.request.clearArgs()
                        for(let key in form) {
                            let value = form[key]
                            let field = Core.Array.findByKey(this.dataFormStructure.fields, 'id', key)
                            this.$refs.request.addArg(key, value, field.type)
                        }
                        this.$refs.request.request()
                        break
                }
            },
            afterTokenization(token, form) {
                this.$refs.request.clearArgs()
                for(let planKey in this.dataPlans) {
                    let plan = this.dataPlans[planKey]
                    if (plan.selected) {
                        this.$refs.request.addArg('plan', planKey)
                    }
                }
                this.$refs.request.addArg('acceptTerms', form['acceptTerms'])
                this.$refs.request.addArg('token', token)
                this.$refs.request.addArg('eventTypes', Core.Value.decode(this.dataEventTypes, Core.Value.typeMultiSelect))
                this.$refs.request.addArg('forceCC', Core.Value.decode(this.dataPlan.forceCC, Core.Value.typeCheckbox))
                this.$refs.request.request()
            },
            prev() {
            },
            requestSuccess(data) {
                this.displayForm(Core.Session.environment.status)
                if (data.plans !== undefined) {
                    this.dataPlans = data.plans
                }
                if (data.environment !== undefined) {
                    this.dataEnvironment = data.environment
                }
                if (data.selectOptions !== undefined) {
                    if (data.selectOptions.eventTypes !== undefined) {
                        this.dataSelectOptions.eventTypes = data.selectOptions.eventTypes
                    }
                }
            },
            requestError(data) {

            },
            login() {
                this.$router.push('/connexion')
            }
        }
    }
</script>
